const selectors = {
  checkbox: '[data-model-checkbox]',
  fieldset: '[data-model-fieldset]',
  modelSelect: '.model-select',
  productGallery: '.product-gallery__main',
  slickSlide: '.slick-slide',
  message: '.model-select__button-content',
  imageGrid: '.product-img__grid-container',
  imageScrollContainer: '.product-img-box-grid',
};

const classes = {
  slideUp: 'model-select__group-up',
  slideDown: 'model-select__group-down',
};

function modelSelector() {
  const container = document.querySelector(selectors.modelSelect);

  if (!container) {
    return;
  }

  const fieldset = container.querySelector(selectors.fieldset);

  if (!fieldset) {
    return;
  }

  const message = container.querySelector(selectors.message);
  const checkbox = container.querySelector(selectors.checkbox);

  if (!checkbox) {
    return;
  }

  const imageScrollContainer = document.querySelector(selectors.imageScrollContainer);
  const imageGrid = document.querySelector(selectors.imageGrid);
  const {children: imageGridItems} = imageGrid;

  const productGallery = document.querySelector(selectors.productGallery);
  const productGallerySlides = productGallery.querySelectorAll(selectors.slickSlide);

  bindEvents();

  removeDisabled();

  const timer = setTimeout(handleUncheck, 4000);

  function bindEvents() {
    fieldset.addEventListener('change', handleChange);
    checkbox.addEventListener('change', handleAnimate);

    document.addEventListener('scroll', handleUncheck);

    imageScrollContainer.addEventListener('scroll', handleUncheck);
  }

  function removeDisabled() {
    const radios = fieldset.querySelectorAll('input[type="radio"]');

    if (!radios || radios.length <= 0) {
      return;
    }

    setTimeout(() => {
      checkbox.removeAttribute('disabled');
      radios.forEach((radio) => radio.removeAttribute('disabled'));
    }, 500);
  }

  function handleAnimate() {
    if (timer) {
      clearTimeout(timer);
    }

    fieldset.classList.toggle(classes.slideUp);
    fieldset.classList.toggle(classes.slideDown);
  }

  function handleUncheck() {
    checkbox.checked = false;

    if (fieldset.classList.contains(classes.slideUp)) {
      handleAnimate();
    }

    document.removeEventListener('scroll', handleUncheck);
    imageScrollContainer.removeEventListener('scroll', handleUncheck);
  }

  function handleChange(event) {
    if (timer) {
      clearTimeout(timer);
    }

    const {target} = event;

    const {modelInfo} = target.dataset;
    const val = target.value;

    message.innerText = modelInfo;

    $(selectors.productGallery).slick('slickUnfilter');

    [...productGallerySlides, ...imageGridItems].forEach((item) => {
      item.classList.remove('hidden');
      const {model} = item.dataset;
      if (model !== val) {
        item.classList.add('hidden');
      }
    });

    $(selectors.productGallery).slick('slickFilter', `:not(.hidden)`);

    handleUncheck();
  }
}

export default modelSelector;
